var App = App || {};

App = (function ($) {
    "use strict";

    var $window = $(window),
        $html = $('html'),
        $body = $('body');

    function init() {
        $('a[href^="#"]')
            .not('.skipto, #sbModalSubmit, [href="#login-modal"]')
            .on('click', function (e) {
                var $this = $(this);

                e.preventDefault();

                if ($this.attr('href') !== '#' && $this.attr('role') !== 'tab') {
                    scrollTo($($this.attr('href')));
                }
            });

        $('a[href="#login-modal"]')
            .attr({
                'data-bs-toggle': 'modal',
                'data-bs-target': '#login-modal'
            });

        onScrollInit($('.os-animation'));

        $('.staggered-animation').each(function () {
            var $this = $(this);
            onScrollInit($this, $this.parents('.staggered-animation-container'));
        });

        let sliders = document.querySelectorAll('.flickity-scroll');

        sliders.forEach((el) => {
            if (el.querySelectorAll('.card').length > 3) {
                var flkty = new Flickity(el, {
                    adaptiveHeight: false,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    watchCSS: true
                });
            }
        });

        $('#routing-copy').on('click', function (e) {
            var copyText = document.getElementById('routing-number');
            navigator.clipboard.writeText(copyText.innerHTML);

            var el = document.getElementById('routing-copy');
            var tooltip = new bootstrap.Tooltip(el);
            tooltip.show();

            setTimeout(() => {
                tooltip.hide();
            }, 1000);
        });
    }

    function addOverlay() {
        $body.addClass('has-overlay');
    }

    function removeOverlay() {
        $body.removeClass('has-overlay');
    }

    function onScrollInit(items, $trigger) {
        items.each(function () {
            var $osElement = $(this),
                osAnimationClass = $osElement.attr('data-os-animation'),
                osAnimationDelay = $osElement.attr('data-os-animation-delay');

            $osElement.css({
                '-webkit-animation-delay': osAnimationDelay,
                '-moz-animation-delay': osAnimationDelay,
                'animation-delay': osAnimationDelay
            });

            var $osTrigger = ($trigger) ? $trigger : $osElement;

            $osTrigger.waypoint(function () {
                var waypoint = this;

                $osElement
                    .one('animationend', function () {
                        $osElement
                            .addClass('animation-complete')
                            .removeClass('animate__animated');

                        waypoint.destroy();
                    })
                    .addClass('animate__animated')
                    .addClass(osAnimationClass);
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }


    function speak(text, priority) {
        var el = document.createElement("div");
        var id = "speak-" + Date.now();
        el.setAttribute("id", id);
        el.setAttribute("aria-live", priority || "polite");
        el.classList.add("sr-only");
        document.body.appendChild(el);

        window.setTimeout(function () {
            document.getElementById(id).innerHTML = text;
        }, 100);

        window.setTimeout(function () {
            document.body.removeChild(document.getElementById(id));
        }, 1000);
    }

    function getQueryString(field, url) {
        var href = url ? url : window.location.href;
        var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
        var string = reg.exec(href);
        return string ? string[1] : null;
    }

    function scrollTo($el) {
        var duration = 600,
            offset = $el.offset().top;

        $('html, body').stop()
            .animate({
                scrollTop: offset
            }, duration);
    }

    return {
        init: init,
        $window: $window,
        $html: $html,
        $body: $body,
        addOverlay: addOverlay,
        removeOverlay: removeOverlay
    };

})(jQuery);

$(function () {
    App.init();
});